import styled from 'styled-components';
import * as Form from '@radix-ui/react-form';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const BotoesLoginRedeSocialContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const FormRoot = styled(Form.Root)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[6]}px;
`;

export const ContainerBotoes = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const ContainerIrParaPaginaCadastro = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: center;

  flex-wrap: wrap;

  margin-top: -${({ theme }) => theme.spacing[4]}px;
`;
